import Table from '@/common/components/Table';
import { TableWrapper } from '../Attachments.styled';
import { headers } from '../constants/tableHeaders';
import { getRows } from '../helpers/getRows';

const AttachmentsTable = ({
	files,
	setShow,
	setSelectedFile,
	handleDownloadFile,
	loadingFiles,
}) => {
	const rows = getRows(
		files,
		loadingFiles,
		setShow,
		setSelectedFile,
		handleDownloadFile,
	);

	return (
		<TableWrapper>
			<Table
				stickyHeader
				className='styled-table'
				headers={headers}
				raws={rows}
			/>
		</TableWrapper>
	);
};

export default AttachmentsTable;
